<div class="row">
    <div class="col-md-12">
      <div class="card AddInsurance_popup">
        <div class="row">
          <div class="col-md-12 mb-lg-0 mb-3">
            <h3 class="font-weight-bold title_size20">Add Nursing Home</h3>
            <div class="card-body p-0">
              <form [formGroup]="NursingHomeForm" (ngSubmit)="submitForm()">
                <!-- Card Holder -->
                <div class="form-group">
                  <label for="card_holder">Name</label>
                  <input type="text" class="form-control" placeholder="Enter name" formControlName="name"/>
                  <mat-error *ngIf="NursingHomeForm.get('name').invalid &&(NursingHomeForm.get('name').dirty ||NursingHomeForm.get('name').touched)">
                    Name is required
                  </mat-error>
                </div>
  
                <div class="row">
                  <div class="col-12 d-flex justify-content-end">
                    <button class="custom-btn mt-3" type="button" (click)="this.dialogRef.close()">
                      Cancel
                    </button>
                    <button class="custom-btn mt-3 ml-2" type="submit">
                      Submit
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  